import styled from 'styled-components'
import media from 'css-in-js-media'

// Button with ripple animation
const Container = styled.section`
    padding-left: 20px;
    padding-right: 20px;
    display: inherit;
    justify-content: inherit;
    align-items: inherit;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    ${media('>desktop')} {
        padding-left: 80px;
        padding-right: 80px;
    }
`

export default Container
